import type { ComponentChildren } from 'preact';

interface StatCardProps {
  label: string;
  value: string;
  subtext?: string;
  highlight?: boolean;
  children?: ComponentChildren;
}

export function StatCard({ label, value, subtext, highlight, children }: StatCardProps) {
  return (
    <div
      class={`flex flex-col p-4 border border-card-border rounded-lg bg-white${highlight ? ' ring-2 ring-hudson-navy/20' : ''}`}
    >
      <span class="text-xs uppercase tracking-wider text-body/70 font-semibold mb-1">
        {label}
      </span>
      <span class="text-2xl font-bold text-hudson-navy leading-tight">{value}</span>
      {subtext && <span class="text-xs text-body/70 mt-0.5">{subtext}</span>}
      {children}
    </div>
  );
}
